var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImprvdLeadQuality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.211,
    height: 46.139,
    viewBox: "0 0 46.211 46.139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "performance_9981832",
    transform: "translate(-1 -1.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(10.603 20.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M27.8,54.6A13.5,13.5,0,1,1,41.3,41.1,13.528,13.528,0,0,1,27.8,54.6Zm0-25.561A12.058,12.058,0,1,0,39.861,41.1,12.08,12.08,0,0,0,27.8,29.044Z",
    transform: "translate(-14.3 -27.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(13.564 23.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M38.618,42.72H35.3A.682.682,0,0,1,34.574,42a5.7,5.7,0,1,0-11.408,0,.682.682,0,0,1-.722.722H19.122A.682.682,0,0,1,18.4,42a10.47,10.47,0,0,1,20.94,0A.682.682,0,0,1,38.618,42.72Zm-2.6-1.444H37.9a9.064,9.064,0,0,0-18.051,0h1.877A7.128,7.128,0,0,1,28.8,34.849,7.269,7.269,0,0,1,36.018,41.276Z",
    transform: "translate(-18.4 -31.6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(21.434 37.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M31.972,57.343a2.672,2.672,0,1,1,2.672-2.672A2.713,2.713,0,0,1,31.972,57.343Zm0-3.9A1.227,1.227,0,1,0,33.2,54.672,1.175,1.175,0,0,0,31.972,53.444Z",
    transform: "translate(-29.3 -52)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(18.546 34.675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M35.7,59.153a.682.682,0,0,1-.722-.722V53.16a4.116,4.116,0,0,0-8.231,0v5.271a.722.722,0,0,1-1.444,0V53.16a5.56,5.56,0,0,1,11.12,0v5.271A.682.682,0,0,1,35.7,59.153Z",
    transform: "translate(-25.3 -47.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(22.084 30.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M33.377,47.41a.682.682,0,0,1-.722-.722V43.15a.505.505,0,1,0-1.011,0v3.538a.722.722,0,0,1-1.444,0V43.15a1.95,1.95,0,1,1,3.9,0v3.538A.682.682,0,0,1,33.377,47.41Z",
    transform: "translate(-30.2 -41.2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(23.384 23.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M32.722,36.293A.682.682,0,0,1,32,35.571V32.322a.722.722,0,0,1,1.444,0v3.249A.682.682,0,0,1,32.722,36.293Z",
    transform: "translate(-32 -31.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(23.384 14.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M32.722,26.848A.682.682,0,0,1,32,26.126v-5.7a.722.722,0,0,1,1.444,0v5.7A.682.682,0,0,1,32.722,26.848Z",
    transform: "translate(-32 -19.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(36.164 20.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M50.422,41.8a.722.722,0,0,1,0-1.444,3.761,3.761,0,0,0,3.827-3.827v-8.3a.722.722,0,1,1,1.444,0v8.3A5.3,5.3,0,0,1,50.422,41.8Z",
    transform: "translate(-49.7 -27.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(6.054 20.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M13.271,41.8A5.3,5.3,0,0,1,8,36.526v-8.3a.722.722,0,0,1,1.444,0v8.3a3.761,3.761,0,0,0,3.827,3.827.722.722,0,0,1,0,1.444Z",
    transform: "translate(-8 -27.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(3.455 6.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M7.794,15.976A3.39,3.39,0,0,1,4.4,12.582V11.86A2.928,2.928,0,0,1,7.36,8.9H8.3a2.928,2.928,0,0,1,2.96,2.96v.722a3.452,3.452,0,0,1-3.466,3.394ZM7.36,10.344A1.575,1.575,0,0,0,5.844,11.86v.722a1.941,1.941,0,0,0,1.95,1.95,2,2,0,0,0,2.022-1.95V11.86A1.575,1.575,0,0,0,8.3,10.344Z",
    transform: "translate(-4.4 -8.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(1 14.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M10.17,26.8H3.527A2.468,2.468,0,0,1,1,24.277,4.408,4.408,0,0,1,5.477,19.8H8.221A4.408,4.408,0,0,1,12.7,24.277,2.558,2.558,0,0,1,10.17,26.8Zm-4.693-5.56a2.961,2.961,0,0,0-3.033,3.033A1.11,1.11,0,0,0,3.527,25.36H10.17a1.109,1.109,0,0,0,1.083-1.083,2.961,2.961,0,0,0-3.033-3.033Z",
    transform: "translate(-1 -19.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(20.712 1.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M31.694,8.176A3.39,3.39,0,0,1,28.3,4.782V4.06A2.928,2.928,0,0,1,31.26,1.1H32.2a2.928,2.928,0,0,1,2.96,2.96v.722a3.452,3.452,0,0,1-3.466,3.394ZM31.26,2.544A1.575,1.575,0,0,0,29.744,4.06v.722a1.941,1.941,0,0,0,1.95,1.95,2,2,0,0,0,2.022-1.95V4.06A1.575,1.575,0,0,0,32.2,2.544Z",
    transform: "translate(-28.3 -1.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(18.329 8.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M34.17,19H27.527A2.468,2.468,0,0,1,25,16.477,4.408,4.408,0,0,1,29.477,12h2.672a4.408,4.408,0,0,1,4.477,4.477A2.5,2.5,0,0,1,34.17,19Zm-4.693-5.56a2.961,2.961,0,0,0-3.033,3.033,1.11,1.11,0,0,0,1.083,1.083H34.17a1.049,1.049,0,0,0,1.011-1.083,2.961,2.961,0,0,0-3.033-3.033Z",
    transform: "translate(-25 -12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(38.041 6.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M55.694,15.976A3.39,3.39,0,0,1,52.3,12.582V11.86A2.928,2.928,0,0,1,55.26,8.9H56.2a2.928,2.928,0,0,1,2.96,2.96v.722A3.55,3.55,0,0,1,55.694,15.976Zm-.433-5.632a1.575,1.575,0,0,0-1.516,1.516v.722a1.941,1.941,0,0,0,1.95,1.95,2.173,2.173,0,0,0,2.022-2.022v-.722A1.575,1.575,0,0,0,56.2,10.272H55.26Z",
    transform: "translate(-52.3 -8.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(35.586 14.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M58.07,26.8H51.427A2.468,2.468,0,0,1,48.9,24.277,4.408,4.408,0,0,1,53.377,19.8h2.672a4.408,4.408,0,0,1,4.477,4.477A2.5,2.5,0,0,1,58.07,26.8Zm-4.693-5.56a2.961,2.961,0,0,0-3.033,3.033,1.11,1.11,0,0,0,1.083,1.083H58.07a1.049,1.049,0,0,0,1.011-1.083,2.961,2.961,0,0,0-3.033-3.033Z",
    transform: "translate(-48.9 -19.8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImprvdLeadQuality);
export default __webpack_public_path__ + "static/media/imprvd-lead-quality.31118e6a6a1a36032909cf6ff4644cf1.svg";
export { ForwardRef as ReactComponent };